// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module--footer--ysHEJ","wave":"Footer-module--wave--nfW-r","content":"Footer-module--content--2oarn","sections":"Footer-module--sections--GZN3K"};